// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./GmarketSansTTFMedium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./GmarketSansTTFBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./KhmerOS_sys.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: "Gmarket";
    font-style: normal;
    font-weight: 100;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  
  @font-face {
    font-family: "Gmarket";
    font-style: normal;
    font-weight: normal;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  
  @font-face {
    font-family: "Gmarket";
    font-style: normal;
    font-weight: 500;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }

  @font-face {
    font-family: "Gmarket";
    font-style: normal;
    font-weight: 600;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }

  @font-face {
    font-family: "Gmarket";
    font-style: normal;
    font-weight: 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  
  @font-face {
    font-family: "Gmarket";
    font-style: normal;
    font-weight: bold;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
  
  @font-face {
    font-family: "Gmarket";
    font-style: normal;
    font-weight: lighter;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }

  @font-face {
    font-family: 'Khmer OS';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); /* 폰트 파일 경로 */
    font-weight: normal;
    font-style: normal;
  }`, "",{"version":3,"sources":["webpack://./src/font/Font.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,4CAAsC;EACxC;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,4CAAsC;EACxC;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,4CAAsC;EACxC;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,4CAAsC;EACxC;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,4CAAsC;EACxC;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,4CAAoC;EACtC;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;IACpB,4CAAsC;EACxC;;EAEA;IACE,uBAAuB;IACvB,4CAA6B,EAAE,aAAa;IAC5C,mBAAmB;IACnB,kBAAkB;EACpB","sourcesContent":["@font-face {\r\n    font-family: \"Gmarket\";\r\n    font-style: normal;\r\n    font-weight: 100;\r\n    src: url(\"./GmarketSansTTFMedium.ttf\");\r\n  }\r\n  \r\n  @font-face {\r\n    font-family: \"Gmarket\";\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    src: url(\"./GmarketSansTTFMedium.ttf\");\r\n  }\r\n  \r\n  @font-face {\r\n    font-family: \"Gmarket\";\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    src: url(\"./GmarketSansTTFMedium.ttf\");\r\n  }\r\n\r\n  @font-face {\r\n    font-family: \"Gmarket\";\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    src: url(\"./GmarketSansTTFMedium.ttf\");\r\n  }\r\n\r\n  @font-face {\r\n    font-family: \"Gmarket\";\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    src: url(\"./GmarketSansTTFMedium.ttf\");\r\n  }\r\n  \r\n  @font-face {\r\n    font-family: \"Gmarket\";\r\n    font-style: normal;\r\n    font-weight: bold;\r\n    src: url(\"./GmarketSansTTFBold.ttf\");\r\n  }\r\n  \r\n  @font-face {\r\n    font-family: \"Gmarket\";\r\n    font-style: normal;\r\n    font-weight: lighter;\r\n    src: url(\"./GmarketSansTTFMedium.ttf\");\r\n  }\r\n\r\n  @font-face {\r\n    font-family: 'Khmer OS';\r\n    src: url('./KhmerOS_sys.ttf'); /* 폰트 파일 경로 */\r\n    font-weight: normal;\r\n    font-style: normal;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
